import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Button } from 'components/buttons/Button/Button';
import { ROUTES } from 'constants/routes';
import { ReactComponent as SVG } from 'images/card-decor.svg';

const ProductCard = ({ index, title, text, img, logo, buttonText }) => {
    const number = String(index + 1).padStart(2, '0');
    let link = '';

    switch (title) {
        case 'Crop nutrition programs':
            link = ROUTES.cropNutritionPrograms;
            break;
        case 'Trial results':
            link = ROUTES.trialResults;
            break;
        case 'Information materials':
            link = ROUTES.informationMaterials;
            break;
        default:
            link = '/';
            break;
    }
    const lastTitleWord = title?.split(' ').pop();

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        gsap.to(`.${lastTitleWord}`, {
            ease: 'none',
            scrollTrigger: {
                trigger: `.${lastTitleWord}`,
                start: 'bottom bottom',
                end: 'top top',
                scrub: true,
                onUpdate: self => {
                    const scrollPercentage = self.progress * 16;
                    gsap.to(`.${lastTitleWord}`, { yPercent: scrollPercentage });
                },
            },
        });
    }, [lastTitleWord]);

    return (
        <div className={`product-card ${index % 2 !== 0 ? 'product-card--reverse' : ''}`}>
            <div className="product-card__image" data-index={'• ' + number}>
                <SVG />
                <img src={img} alt="product-item" className={`product-card__image-bg ${lastTitleWord}`} />
                {logo && (
                    <div className="product-card__image-logo">
                        <img src={logo} alt="product-logo" />
                    </div>
                )}
            </div>
            <div className="product-card__content">
                <h3>{title}</h3>
                <p className="body1">{text}</p>
                <Button type="learn-more-arrow" href={link}>
                    {buttonText}
                </Button>
            </div>
        </div>
    );
};

export default ProductCard;
